export enum LoginPageLayoutEnum {
  TWO_COLUMN = 'two-column',
  CENTER = 'center'
}